// extracted by mini-css-extract-plugin
export default {"wrapper":"AuthorFilter_wrapper__4T9Rd","search":"AuthorFilter_search__hflDm"};